export default "__VITE_ASSET__C_A3lNhm__"